module.exports = __webpack_public_path__ + "img/0f74991.jpg";